export default __webpack_public_path__ + "locales/fr/ConnectDialog.json?hash=e144b25217d127e2a0ee0a3f6027bfa0";